import { useMemo } from "react";
import Assign from "../../components/modals/Assign";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useAssignModal = () => {
    const { open, visible, close, selected } = useVisible();

    const modal = useMemo(() => {
        return <Assign visible={visible} values={selected} close={close} />;
    }, [visible, selected, close]);

    return { open, modal };
};
